import Button from "$store/components/ui/Button.tsx";
import {
  Options as UseAddToCartProps,
  useAddToCart,
} from "$store/sdk/useAddToCart.ts";
import { type ComponentChildren } from "preact";

interface Props extends UseAddToCartProps {
  /**
   * @description Product id
   */
  sellerId: string;
  class?: string;
  onClick?: () => void;
  children?: ComponentChildren;
}

function AddToCartButton(
  {
    skuId,
    sellerId,
    discount,
    price,
    productGroupId,
    name,
    quantity,
    analytics,
    class: _class,
    onClick,
    children,
  }: Props,
) {
  const props = useAddToCart({
    skuId,
    sellerId,
    discount,
    price,
    productGroupId,
    name,
    quantity,
    analytics,
  });

  return (
    <Button
      data-deco="add-to-cart"
      loading={props.loading}
      onClick={(e) => {
        if (onClick) onClick();
        if (skuId) props.onClick(e);
      }}
      class={_class}
    >
      {children}
    </Button>
  );
}

export default AddToCartButton;
